/* eslint-disable no-underscore-dangle */
// https://babeljs.io/docs/en/next/babel-plugin-syntax-dynamic-import#working-with-webpack-and-babel-preset-env
import 'core-js/modules/es.promise';
import 'core-js/modules/es.array.iterator';
import 'react-dates/initialize';
import React from 'react';
import { hydrate } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import createHistory from 'history/createBrowserHistory';
import * as Loadable from 'react-loadable';
import { renderRoutes } from 'react-router-config';
import dbg from 'debug';
import querystring from 'query-string';
import bugsnagReact from '@bugsnag/plugin-react';
import createStore from './create';
import bugsnagClient from './helpers/BugsnagClient';
import getRoutes from './routes';
import { getQueryParam, getCookieValue } from './helpers/utils';
import { client } from './api/Api';
import config from '../config/config';

import '../static/main.scss';
import '../static/vendor.scss';

const debug = dbg('jp:client');

if (__CLIENT__ && !window.location.origin) {
  const value = `${window.location.protocol}//${window.location.hostname}${
    window.location.port ? `:${window.location.port}` : ''
  }`;
  try {
    Object.defineProperty(window.location, 'origin', {
      value,
      enumerable: true
    });
  } catch (err) {
    window.location.origin = value;
  }
}

const history = createHistory();

if (__CLIENT__ && __DEVELOPMENT__) {
  history.listen((location, action) => {
    // location is an object like window.location
    debug({
      action,
      pathname: location.pathname,
      query: querystring.parse(location.search),
      state: location.state,
      next: window.history.next,
      previous: window.history.previous
    });
  });
}

if (window && window.__data && window.__data.ui) {
  // https://github.com/tonyhb/redux-ui/issues/24
  delete window.__data.ui;
}
const store = createStore(history, client, window.__data);

if (__CLIENT__) {
  // This fires on the initial page load
  client
    .track({
      referrer: document.referrer,
      requestUri: window.location.href,
      source: getQueryParam(window.location.href, 'source')
    })
    .catch(console.error);

  // Store an initial session in the local storage if one doesn't exist already
  // This is used for referral tracking
  const jpTracking = getCookieValue('jp_session');
  if (!jpTracking) {
    let affiliateId = getQueryParam(window.location.href, 'aff');
    affiliateId = affiliateId ? affiliateId.replace('aff', '') : null;
    const inviteCode = getQueryParam(window.location.href, 'invite_code');

    client.longSession({
      referrer: document.referrer,
      requestUri: window.location.href,
      affiliateId: Number.isNaN(affiliateId) ? null : affiliateId,
      inviteCode
    });
  }
}

history.listen(() => {
  // Bugsnag by default will only report first ten errors on a pages
  // - so we trigger a refresh on context change each time here
  bugsnagClient.refresh();
});

bugsnagClient.use(bugsnagReact, React);

const ErrorBoundary = bugsnagClient.getPlugin('react');

Loadable.preloadReady().then(() => {
  const mountNode = document.getElementById('content');
  hydrate(
    <ErrorBoundary>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          {renderRoutes(getRoutes())}
        </ConnectedRouter>
      </Provider>
    </ErrorBoundary>,
    mountNode
  );
});

if (!config.isProduction) {
  window.React = React; // enable debugger
}
